












import Vue from 'vue'
import { getCalendarData, mountAppointmentModal, unmountAppointmentModal } from '../../util/calendar_modal'

export default Vue.extend({
  name: 'AppointmentList',
  data() {
    return {
      currentLocationId: ''
    }
  },
  async created() {
    this.currentLocationId = this.$router.currentRoute.params.location_id
  },
  mounted() {
    this.mountAppointmentListApp()
  },
  beforeDestroy() {
    unmountAppointmentModal('AppointmentList')
  },
  methods: {
    async mountAppointmentListApp() {
        const data = await getCalendarData(this.currentLocationId);
        mountAppointmentModal('AppointmentList', {
          route: this.$route,
          router: this.$router,
          data: data,
          store: data.store
        })
      }
  },
  watch: {
    '$route.params.location_id': async function(id) {
      this.currentLocationId = id
      this.mountAppointmentListApp()
    },
  },
})
